import getConfig from 'next/config';
import dynamic from 'next/dynamic';
import { useState, useEffect } from 'react';
import fetchGuidedSearch from '~/api/helpers/fetchGuidedSearch';

const GuidedSearchNoSSR = dynamic(
  () => import('../../organisms/GuidedSearch'),
  {
    ssr: false,
  },
);
/**
 * GuidedSearch
 * @param {GuidedSearchApiProps}
 */

const GuidedSearchContainer = ({
  rootNodeId,
  rootNodeType,
  language,
  formType,
  parentContainerType,
  isBrand,
}) => {
  const { publicRuntimeConfig } = getConfig();
  const lang = language || publicRuntimeConfig.defaultLanguage;
  /**
   * @type {GuidedSearchResultApiProps | undefined}
   */
  const [guidedSearchItems, setGuidedSearchItems] = useState();

  /**
   * @param id
   * @param type
   */
  const handleFetch = (id, type) => {
    fetchGuidedSearch(id, type, lang).then((response) =>
      setGuidedSearchItems(response),
    );
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    handleFetch(rootNodeId, rootNodeType);
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <GuidedSearchNoSSR
      items={guidedSearchItems}
      onChange={(id, type) => handleFetch(id, type)}
      formType={formType}
      parentContainerType={parentContainerType}
      isBrand={isBrand}
    />
  );
};

export default GuidedSearchContainer;
